import { render, staticRenderFns } from "./noticeRules.vue?vue&type=template&id=6c646b8a&scoped=true&"
import script from "./noticeRules.vue?vue&type=script&lang=js&"
export * from "./noticeRules.vue?vue&type=script&lang=js&"
import style0 from "./noticeRules.vue?vue&type=style&index=0&id=6c646b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c646b8a",
  null
  
)

export default component.exports